export default __webpack_public_path__ + "static/3-b0369c122dda3ffd2b9ab6a210d3ac90.png";